<div class="nsw-p-top-sm">
    <h2>Nearby monitored swim sites</h2>
    <div class="row mt-3">
        <div class="col-12 col-lg-4 pb-2" *ngFor="let nearbySite of nearbySitesModel">
            <app-nearby-site-widget [siteName]="nearbySite.SiteName" [distanceM]="nearbySite.DistanceM"
                [identifier]="nearbySite.Identifier" [sitePhoto]="nearbySite.SitePhoto">
            </app-nearby-site-widget>
        </div>
    </div>
</div>
